import React, { useEffect, useRef } from "react";
import {
  Card,
  Typography,
  Form,
  Input,
  Row,
  Col,
  Button,
  message,
  Spin,
} from "antd";
import {
  BackwardOutlined,
  FormOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../api/Axios";
import DynamicSelect from "../../../../components/AdminComponents/customHooks/DynamicSelect";
const { Title, Paragraph } = Typography;

const Edit = ({ data1, loading, LoadUser }) => {
  console.log(data1);
  const history = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const userInfo = useSelector((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();

  const CreateSuccessfull = (id) => {
    messageApi.open({
      type: "success",
      content: "Bundle edit success.",
      duration: 5,
    });
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Bundle edit failure",
      duration: 5,
    });
  };
  const formRef = useRef();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const finalValues = {
      ...normalizedValues,
      organization: userInfo?.data?.organization?.id,
    };

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.put(`learn/bundle/${id}`, finalValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      CreateSuccessfull(res.data.id);
    } catch (err) {
      CreateFailed();
    }
  };
  const loadForm = React.useCallback(() => {
    if (!loading && formRef.current) {
      const formValues = {
        role_id: data1?.role_id,
        job_category: data1?.job_category,
        job_group: data1?.job_group,
        location: data1?.location?.id || null,
        name: data1?.name,
        description: data1?.description,
      };
      formRef.current.setFieldsValue(formValues);
    }
  }, [loading, data1]);
  const handleReset = () => {
    loadForm();
  };
  useEffect(() => {
    if (!loading && formRef.current) {
      loadForm();
    }
  }, [loading, data1, loadForm]);

  return (
    <Card
      style={{
        width: "100%",
        marginBottom: "10px",
      }}
      hoverable
    >
      <Spin spinning={loading}>
        {contextHolder}
        <Title level={4} style={{ letterSpacing: "0.5px" }}>
          Role Information
        </Title>
        <Paragraph type="secondary">
          Edit and configure your existing Role with the details below
        </Paragraph>

        <Form
          layout="vertical"
          onFinish={handleSubmit}
          name="complex-form"
          ref={formRef}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                label="Role ID"
                required
                rules={[
                  {
                    required: true,
                    message: "ID is required",
                  },
                ]}
                name="role_id"
              >
                <Input placeholder="Enter ID" />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item
                label="Role Name"
                required
                rules={[
                  {
                    required: true,
                    message: "name is required",
                  },
                ]}
                name="name"
              >
                <Input placeholder="Enter name" />
              </Form.Item>
            </Col>

            <Col span={9}>
              <Form.Item label="Job Category" name="job_category">
                <Input placeholder="Enter Category" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={9}>
              <Form.Item label="Job Group" name="job_group">
                <Input placeholder="Enter group" />
              </Form.Item>
            </Col>
            <Col span={9}>
              <DynamicSelect
                name="location"
                label="Location"
                url={`locationlist/${userInfo.data.organization.id}/`}
                variant="single"
                initialValue={data1?.location}
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Role Description" name="description">
                <Input.TextArea rows={4} placeholder="Enter description" />
              </Form.Item>
            </Col>
          </Row>
          <div
            className="group-1-box"
            style={{
              paddingTop: "0rem",
              paddingLeft: "0px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <div>
              <div style={{ display: "inline-block" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    onClick={() => {
                      history(
                        isCAAdmin
                          ? "/ca-admin/trainery-learn/bundles/listing"
                          : "/trainery-learn/bundles/listing"
                      );
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    // className="save-update-btn"
                    disabled
                    // style={{
                    //   background: "#f58029",
                    // }}
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    onClick={handleReset}
                    style={{
                      background: "#D3D3D3",
                    }}
                  >
                    Reset
                    <RetweetOutlined />
                  </Button>
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </Spin>
    </Card>
  );
};

export default Edit;
